export const GOOGLE = 'google';
export const MAPKITJS = 'mapkitjs'; // apple maps